import React from 'react';
import { Table, Tooltip, Whisper } from 'rsuite';
import { LinkButton } from '../../../../../../../components';
import { LoadingSpinerArea } from '../../../../../../../components/LoadingSpinner';
import CurrencyFormat from 'react-currency-format';
import {
  applyDiscount,
  descontoMaximoTagCalc,
  margemOperacionalTagCalc,
  PMZComercialCalc,
  tabelaAtualComercialPercentage,
} from '../../ConsultComercialTable.calculos';
import styles from './RetailConsultCurrentTable.module.scss';
import { useManageComercialTableStore } from '../../../ManageComercialTable/ManageComercialTable.store';
import { promoDueDateFormat } from '../../../../utils';

type RetailConsultCurrentTableProps = {
  data?: any;
  onChangeCheckbox?: (rowData: any, checked: boolean) => void;
  onChangeLength?: (value: number) => void;
  onChangePage?: (value: number) => void;
};

const { Column, HeaderCell, Cell, Pagination } = Table;

const lengthMenu = [
  {
    value: 10,
    label: 10,
  },
  {
    value: 20,
    label: 20,
  },
];

export const RetailConsultCurrentTable = ({ data, onChangePage, onChangeLength }: RetailConsultCurrentTableProps) => {
  const { comercialTablePriceLimitAndRules } = useManageComercialTableStore();

  const regras = comercialTablePriceLimitAndRules.regras ? comercialTablePriceLimitAndRules.regras[0] : {};

  return (
    <div className={styles['table-consult-current-container']}>
      <LoadingSpinerArea area="consult-comercial-table" />
      <Table
        data={data?.data?.content}
        autoHeight
        id="consultar-tabela-comercial"
        className={styles['table-scenario']}
        rowClassName={styles['table-scenario-row']}
        rowHeight={64}
        headerHeight={46}
      >
        <Column flexGrow={2}>
          <HeaderCell>Produto</HeaderCell>
          <Cell dataKey="produto" height={60}>
            {rowData => (
              <Whisper delayShow={0.2} trigger="hover" placement="bottom" speaker={<Tooltip>{rowData.produtoBase?.produto.descricaoProduto}</Tooltip>}>
                <div>
                  <p className={styles['main-bold-text']}>{rowData.produtoBase.produto.codigoInternoProduto}</p>
                  <p className={styles['subtext-bold']}>{rowData.produtoBase.produto.descricaoProduto}</p>
                </div>
              </Whisper>
            )}
          </Cell>
        </Column>
        <Column flexGrow={1}>
          <HeaderCell>Família</HeaderCell>
          <Cell dataKey="familia" height={60}>
            {rowData => (
              <div className={styles.flex}>
                <p className={styles['regular-text-family']}>{rowData.produtoBase.produto.categoriaNivel1}</p>
              </div>
            )}
          </Cell>
        </Column>
        <Column flexGrow={1}>
          <HeaderCell>UF</HeaderCell>
          <Cell dataKey="uf">
            {rowData => (
              <div className={styles.flex}>
                <p className={styles['regular-text']}>{rowData.uf}</p>
              </div>
            )}
          </Cell>
        </Column>
        <Column flexGrow={1}>
          <HeaderCell className={styles.line}>
            <span className={styles['flex-column']}>
              <p>Custo</p>
              <p>fabricação</p>
            </span>
          </HeaderCell>
          <Cell dataKey="custoFabricacao" className={styles.line}>
            {rowData => (
              <div>
                <p className={styles['main-bold-text']}>
                  <CurrencyFormat
                    fixedDecimalScale={true}
                    decimalScale={2}
                    value={rowData.parametros.custoFabricacao}
                    displayType={'text'}
                    prefix={'R$ '}
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                  />
                </p>
              </div>
            )}
          </Cell>
        </Column>
        <Column flexGrow={1}>
          <HeaderCell>
            <span className={styles['flex-column']}>
              <p>Outros</p>
              <p>custos</p>
            </span>
          </HeaderCell>
          <Cell dataKey="outros">
            {rowData => (
              <div className={styles['main-bold-text']}>
                <p className={styles['main-bold-text']}>
                  <CurrencyFormat
                    fixedDecimalScale={true}
                    decimalScale={2}
                    value={rowData.produtoBase.produto.mediaCustoProducao}
                    displayType={'text'}
                    prefix={'R$ '}
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                  />
                </p>
                <LinkButton fontSize="10px">Editar</LinkButton>
              </div>
            )}
          </Cell>
        </Column>
        <Column flexGrow={1}>
          <HeaderCell>PMZ</HeaderCell>
          <Cell dataKey="pmz">
            {rowData => (
              <div>
                <p className={styles['main-bold-text']}>
                  <CurrencyFormat
                    fixedDecimalScale={true}
                    decimalScale={2}
                    value={PMZComercialCalc(rowData)}
                    displayType={'text'}
                    prefix={'R$ '}
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                  />
                </p>
              </div>
            )}
          </Cell>
        </Column>
        <Column flexGrow={1}>
          <HeaderCell className={styles.line}>
            <span className={styles['flex-column']}>
              <p>Preço</p>
              <p>tabela</p>
            </span>
          </HeaderCell>
          <Cell dataKey="tabelaAtual" className={styles.line}>
            {rowData => (
              <div>
                <p className={styles['main-bold-text']}>
                  <CurrencyFormat
                    fixedDecimalScale={true}
                    decimalScale={2}
                    value={rowData.parametros.precoTabela || 0}
                    displayType={'text'}
                    prefix={'R$ '}
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                  />
                </p>
                <p className={styles.subtext}>
                  <CurrencyFormat
                    fixedDecimalScale={true}
                    decimalScale={1}
                    value={tabelaAtualComercialPercentage(rowData)}
                    displayType={'text'}
                    prefix={'$ '}
                    suffix="%"
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                  />
                </p>
              </div>
            )}
          </Cell>
        </Column>
        <Column flexGrow={1}>
          <HeaderCell>
            <span className={styles['flex-column']}>
              <p>Desconto</p>
              <p>máximo</p>
            </span>
          </HeaderCell>
          <Cell dataKey="margemLucroBruto">
            {rowData => (
              <div>
                <p className={styles['main-bold-text']}>{regras.descontoMaximo}%</p>
              </div>
            )}
          </Cell>
        </Column>
        <Column flexGrow={1}>
          <HeaderCell>
            <span className={styles['flex-column']}>
              <p>Preço c/</p>
              <p>desconto</p>
            </span>
          </HeaderCell>
          <Cell dataKey="margemLucroOperacional">
            {rowData => (
              <div>
                <p className={styles['main-bold-text']}>
                  <CurrencyFormat
                    fixedDecimalScale={true}
                    decimalScale={2}
                    value={applyDiscount(regras.descontoMaximo, rowData.parametros.precoTabela)}
                    displayType={'text'}
                    prefix={'R$ '}
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                  />
                </p>
                <p className={styles.subtext}>
                  <CurrencyFormat
                    fixedDecimalScale={true}
                    decimalScale={1}
                    value={descontoMaximoTagCalc(regras.descontoMaximo, rowData.parametros.precoTabela)}
                    displayType={'text'}
                    prefix={'$ '}
                    suffix="%"
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                  />
                </p>
              </div>
            )}
          </Cell>
        </Column>
        <Column flexGrow={1}>
          <HeaderCell className={styles.line}>
            <span className={styles['flex-column']}>
              <p>Preço</p>
              <p>oferta</p>
            </span>
          </HeaderCell>
          <Cell dataKey="tabelaAtual" className={styles.line}>
            {rowData => (
              <div>
                <p className={styles['main-bold-text']}>
                  {rowData?.oferta ? (
                    <CurrencyFormat
                      fixedDecimalScale={true}
                      decimalScale={2}
                      value={rowData?.oferta?.preco}
                      displayType={'text'}
                      prefix={'R$ '}
                      decimalSeparator={','}
                      thousandSeparator={'.'}
                    />
                  ) : (
                    'R$ -'
                  )}
                </p>
                <p className={styles.subtext}>
                  {rowData?.oferta ? (
                    <CurrencyFormat
                      fixedDecimalScale={true}
                      decimalScale={1}
                      value={margemOperacionalTagCalc(PMZComercialCalc(rowData), rowData.parametros.precoTabela)}
                      displayType={'text'}
                      prefix={'$ '}
                      suffix="%"
                      decimalSeparator={','}
                      thousandSeparator={'.'}
                    />
                  ) : (
                    '$ -'
                  )}
                </p>
              </div>
            )}
          </Cell>
        </Column>
        <Column flexGrow={1}>
          <HeaderCell>
            <span className={styles['flex-column']}>
              <p>Desconto</p>
              <p>oferta</p>
            </span>
          </HeaderCell>
          <Cell dataKey="margemLucroBruto">
            {rowData => (
              <div>
                <p className={styles['main-bold-text']}>
                  {rowData?.oferta ? (
                    <CurrencyFormat
                      fixedDecimalScale={true}
                      decimalScale={1}
                      value={margemOperacionalTagCalc(rowData.oferta?.preco, rowData.parametros?.precoTabela)}
                      displayType={'text'}
                      suffix="%"
                      decimalSeparator={','}
                      thousandSeparator={'.'}
                    />
                  ) : (
                    '-'
                  )}
                </p>
              </div>
            )}
          </Cell>
        </Column>
        <Column flexGrow={1}>
          <HeaderCell>
            <span className={styles['flex-column']}>
              <p>Validade</p>
              <p>oferta</p>
            </span>
          </HeaderCell>
          <Cell dataKey="margemLucroOperacional">
            {rowData => (
              <div>
                <p className={styles['regular-text']}>
                  {rowData?.oferta ? (
                    <>
                      {promoDueDateFormat(rowData?.oferta?.inicio)} a
                      <br />
                      {promoDueDateFormat(rowData?.oferta?.fim)}
                    </>
                  ) : (
                    '-'
                  )}
                </p>
              </div>
            )}
          </Cell>
        </Column>
      </Table>
      <Pagination
        activePage={data?.data.page.number + 1 || null}
        displayLength={data?.data.page.size}
        total={data?.data.page.totalElements || null}
        onChangePage={onChangePage}
        onChangeLength={onChangeLength}
        lengthMenu={lengthMenu}
      />
    </div>
  );
};
